<template>
  <select
    class="select v-stack gap-1 form-select form-control"
    v-if="options.length"
    v-model="model"
    v-bind="$attrs"
    @change="onChange"
    @focus="hasFocus = true"
    @blur="hasFocus = false">
    <option v-for="option in options"
      :selected="value === option.value"
      :id="[name, option.value].join('_')"
      :key="option"
      :value="option.value ?? option.label"
    >{{ option.label }}</option>
  </select>
</template>

<script>

export default {
  name: "Select",
  emits: ["update:value", "change"],
  props: {
    name: {
      value: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
      default() {
        return ""
      }
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => {
        const hasLabelKey = value.every((option) =>
          Object.keys(option).includes("label")
        );
        return hasLabelKey
      },
    }
  },
  data() {
    return {
      config: {},
      model: this.value || null,
      Drupal: this.$drupal,
    }
  },
  methods: {
    onChange(e) {
      this.$emit("change", this.model)
    }
  },
  watch: {
    "value"(to, from) {
      if (to !== from) {
        this.model = to
      }
    },
  },
};
</script>
